import { faMagicWandSparkles, faMobile, faShield } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Content from 'assets/js/components/Content';
import * as GivebutterPlusSplash from 'components/givebutter-plus-splash/GivebutterPlusSplash';
import * as SubNav from 'components/sub-nav';
import { EngageSubNavTabs } from 'components/sub-nav/EngageSubNavTabs';
import { NONPROFIT_VERIFICATION_LINK } from 'constants/links';
import TextingSplash from 'images/texting-splash.webp';

const TextingGivebutterPlusSplashPage = () => {
    return (
        <Content className="flex flex-col gap-y-4">
            <SubNav.Root>
                <SubNav.Header>
                    <SubNav.Title>Engage</SubNav.Title>
                </SubNav.Header>
                <EngageSubNavTabs />
            </SubNav.Root>
            <GivebutterPlusSplash.Root>
                <GivebutterPlusSplash.Content className="max-w-full p-0">
                    <GivebutterPlusSplash.Header>
                        <GivebutterPlusSplash.Text>
                            <GivebutterPlusSplash.HeaderLogo />
                            <GivebutterPlusSplash.Title>Texts</GivebutterPlusSplash.Title>
                            <GivebutterPlusSplash.Description>
                                Boost your fundraising with text messaging. Instantly and securely
                                connect with your supporters through their mobile phones, all in a
                                simple and compliant way.
                            </GivebutterPlusSplash.Description>
                            <GivebutterPlusSplash.CallToAction />
                        </GivebutterPlusSplash.Text>
                        <GivebutterPlusSplash.HeaderImage>
                            <img src={TextingSplash} alt="Texts illustration" />
                        </GivebutterPlusSplash.HeaderImage>
                    </GivebutterPlusSplash.Header>
                    <div className="flex flex-col gap-2.5">
                        <GivebutterPlusSplash.FeatureCardRow>
                            <GivebutterPlusSplash.FeatureCard>
                                <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-1">
                                    <FontAwesomeIcon icon={faMobile} size="xl" />
                                </GivebutterPlusSplash.FeatureCardIcon>
                                <GivebutterPlusSplash.FeatureCardText>
                                    <GivebutterPlusSplash.FeatureCardTextHeading>
                                        Unique phone number
                                    </GivebutterPlusSplash.FeatureCardTextHeading>
                                    <GivebutterPlusSplash.FeatureCardTextDescription>
                                        Select your own, custom 10-digit-long code (10DLC) for
                                        supporters to text you with.
                                    </GivebutterPlusSplash.FeatureCardTextDescription>
                                </GivebutterPlusSplash.FeatureCardText>
                            </GivebutterPlusSplash.FeatureCard>

                            <GivebutterPlusSplash.FeatureCard>
                                <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-2">
                                    <FontAwesomeIcon icon={faShield} size="xl" />
                                </GivebutterPlusSplash.FeatureCardIcon>
                                <GivebutterPlusSplash.FeatureCardText>
                                    <GivebutterPlusSplash.FeatureCardTextHeading>
                                        Secure &amp; compliant
                                    </GivebutterPlusSplash.FeatureCardTextHeading>
                                    <GivebutterPlusSplash.FeatureCardTextDescription>
                                        Ensure that your messages are legal, compliant, and meet all
                                        industry standards.
                                    </GivebutterPlusSplash.FeatureCardTextDescription>
                                </GivebutterPlusSplash.FeatureCardText>
                            </GivebutterPlusSplash.FeatureCard>

                            <GivebutterPlusSplash.FeatureCard>
                                <GivebutterPlusSplash.FeatureCardIcon className="bg-gbp-gradient-3">
                                    <FontAwesomeIcon icon={faMagicWandSparkles} size="xl" />
                                </GivebutterPlusSplash.FeatureCardIcon>
                                <GivebutterPlusSplash.FeatureCardText>
                                    <GivebutterPlusSplash.FeatureCardTextHeading>
                                        Key-word autoresponder
                                    </GivebutterPlusSplash.FeatureCardTextHeading>
                                    <GivebutterPlusSplash.FeatureCardTextDescription>
                                        Streamline communications by setting up auto-responses to
                                        common inquiries and responses
                                    </GivebutterPlusSplash.FeatureCardTextDescription>
                                </GivebutterPlusSplash.FeatureCardText>
                            </GivebutterPlusSplash.FeatureCard>
                        </GivebutterPlusSplash.FeatureCardRow>
                        <div className="text-sm text-gray-600">
                            <a
                                href={NONPROFIT_VERIFICATION_LINK}
                                className="font-normal text-gray-600 underline hover:text-gray-800"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Account verification
                            </a>{' '}
                            is required to enable text messaging, even for Givebutter Plus
                            subscribers.
                        </div>
                    </div>
                    <GivebutterPlusSplash.Footer />
                </GivebutterPlusSplash.Content>
            </GivebutterPlusSplash.Root>
        </Content>
    );
};

export { TextingGivebutterPlusSplashPage };
